module.exports = __webpack_public_path__ + "img/nighthawk-app-icon.0d6b8e03.svg";